// extracted by mini-css-extract-plugin
module.exports = {"feature-box":"feature-box_3SlQ","feature-list":"feature-list_3Ao8","feature-item":"feature-item_1q0n"};